import { Checkbox, FormControlLabel } from '@mui/material'
import React from 'react'
import { CustomInput, CustomSelect, selectTypes } from 'src/consumer/components/helperComponents'
import { FOOTER_TYPES_ARRAY } from 'src/consumer/constants'
import { getChangedNumberValueFromInput, getNumberStringForInput } from 'src/mentor/helpers/utilityFunctions'

export default function PrintFooterSettings({ footerSettings, setFooterSettings }) {
  return (
    <>
      <div className="pt-3">
        <strong>Footer Settings</strong>
        <div className="d-flex flex-column gap-1">
          <CustomSelect
            id="footerStyle"
            value={footerSettings?.footerStyle}
            label="Footer Type"
            selectType={selectTypes.string}
            options={FOOTER_TYPES_ARRAY}
            getOptionValue={(optn) => {
              return optn?.id
            }}
            getOptionLabel={(optn) => {
              return optn?.title
            }}
            onChangeEvent={(e) => {
              setFooterSettings((prev) => ({
                ...prev,
                footerStyle: e.target.value,
              }))
            }}
          />
        </div>
      </div>
      <div className="pt-1">
        <div className="d-flex flex-column gap-1">
          <FormControlLabel
            control={
              <Checkbox
                checked={footerSettings?.showBlankFooter}
                onChange={(e) => {
                  setFooterSettings((prev) => ({ ...prev, showBlankFooter: e.target.checked }))
                }}
              />
            }
            label="Show blank footer"
          />
        </div>
      </div>
      <div className="pt-1">
        <div className="d-flex flex-column gap-1">
          <CustomInput
            id="footerHeight"
            value={getNumberStringForInput(footerSettings?.footerHeight)}
            label="Footer Height in Inches"
            type="number"
            onChange={(e) => {
              setFooterSettings((prev) => ({
                ...prev,
                footerHeight: getChangedNumberValueFromInput(e.target.value),
              }))
            }}
          />
        </div>
      </div>
    </>
  )
}
